import { reactive } from 'vue';
import { POST } from '@/packge/http';
import { MD5 } from 'crypto-js';

export let pwdState = reactive({ newPassword: '', confirmPassword: '' });

/** 修改密码 */
export function submitChangePwd () {
  let data = { ...pwdState };
  data.newPassword = MD5(data.newPassword).toString();
  data.confirmPassword = MD5(data.confirmPassword).toString();

  return new Promise(resolve => {
    POST({
      url: '/account/updatePwd',
      params: data
    }).then(({ data }) => {
      pwdState.newPassword = '';
      pwdState.confirmPassword = '';
      resolve(data);
    });
  });
}

export function samePassword (rule, value, callback) {
  let pwdVal = pwdState.newPassword;
  if (value !== pwdVal) {
    callback(new Error('两次密码不一致'));
  } else {
    callback();
  }
}
